import {getMpEnv} from '@qnpm/vc_jump';
export default getMpEnv;